// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3_wv8","col":"styles_col__2FJgd"};